import React, { useState } from 'react';
import { BygrProfileUnits, BygrUserDetails, BygrUserProjectMembership } from 'types';
import { createDataTable } from 'components/DataTable';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';

export interface UserProjectsProps {
    user: BygrUserDetails;
    reload(): void;
}
const UnitsTable = createDataTable<BygrProfileUnits>();

export const UserUnits: React.FC<UserProjectsProps> = ({ user }) => {
    const [memberTableState, setMemberTableState] = useState(UnitsTable.getInitialState('unitId'));

    return (
        <UnitsTable
            hasPagination={false}
            data={user.units}
            onStateChange={setMemberTableState}
            state={memberTableState}
            totalItemCount={user.projectMemberships.length}
            className="table style-3">
            <UnitsTable.Column header="Unit Id" field="unitId" renderer={({ value }) => value} />
            <UnitsTable.Column
                header="Unit Name"
                field="unitName"
                renderer={({ row }) => (
                    <CustomLink to={`/projects/${row.projectId}/units/${row.unitId}`}>{row.unitName}</CustomLink>
                )}
            />
            <UnitsTable.Column header="Project Id" field="projectId" renderer={({ value }) => value} />
            <UnitsTable.Column
                header="Project Name"
                field="projectName"
                renderer={({ value, row }) => <CustomLink to={`/projects/${row.projectId}`}>{value}</CustomLink>}
            />
            <UnitsTable.Column header="Contract Status" field="contractStatus" renderer={({ value }) => value} />
        </UnitsTable>
    );
};
